export default __webpack_public_path__ + "static/countdown_widget_collapsed-14e4479315e0a48802c91f06ebf309dc.png";